import { Toast } from 'vant'
import router from '../router/index'
import store from '../store/index'

window.QUERY_STATUS = {
    未开始: 1,
    进行中: 2,
    已结束: 3
}

class NavigationTool {
    static get configurationModel() {
        return store.state.configurationModel
    }

    static get accountModel() {
        return store.state.accountModel
    }

    static get isLogin() {
        return store.getters['user/isAuthenticated']
    }

    // 页面导航逻辑
    static appNavigate() {
        // 任务未开始或已结束
        if (this.configurationModel.model.status != QUERY_STATUS.进行中) {
            const info = findKey(QUERY_STATUS, this.configurationModel.model.status)
            this.navigateToError(info)
            return
        }
        //是否允许自主注册 1-否 2-是
        if (this.configurationModel.model.register === 1) {
            const info = findKey(QUERY_STATUS, QUERY_STATUS.已结束)
            this.navigateToError(info)
            return
        }
        // 任务需要登录
        // if (this.configurationModel.needLogin && !this.isLogin) {
        //     this.navigateToLogin()
        //     return
        // }
        //存在任务简介
        if (this.configurationModel.needShowDescription) {
            const description = this.configurationModel.model.desc
            this.navigateToDescription(description)
            return
        }
        // 完善用户信息
        this.navigateToComplete()
    }


    static descriptionNavigate() {
        // 显示完善信息
        if (!this.accountModel?.isAccountInfoComplete) {
            this.navigateToComplete()
        } else {
            this.completeNavigate()
        }
    }

    static completeNavigate() {
        // 显示结果
        const result = this.accountModel?.result
        console.log(result);
        // 不能重新测试 且 有resultID（已登陆） 且 resultID不为0（已测过）
        if (this.configurationModel.canReSubmit == false && result != undefined && result != null) {
            const isFromQuery = false
            const resultIds = result.map(el => el.id).join(',')
            this.navigateToResultList(isFromQuery, resultIds)
            return
        }
        this.queryNavigate()
    }

    static queryNavigate() {
        // 显示任务(列表)
        if (this.configurationModel.needShowQueryList) {
            this.navigateToQueryList()
        } else {
            const assessmentItem = this.configurationModel.assessmentArray[0]
            this.navigateToQuery(assessmentItem)
        }
    }

    // 导航方法
    static navigateToError(info) {
        router.push({
            name: 'Error',
            query: {
                info: info
            }
        })
    }

    static navigateToLogin() {
        router.push({
            name: 'Login'
        })
    }

    static navigateToDescription(description) {
        router.push({
            name: 'Description',
            query: {
                description
            }
        })
    }

    static navigateToComplete() {
        router.push({
            name: 'Complete'
        })
    }

    static navigateToQuery(assessmentItem) {
        router.push({
            name: 'Query',
            query: {
                assessmentItem
            }
        })
    }

    static navigateToQueryList() {
        router.push({
            name: 'QueryList'
        })
    }

    static navigateToResultList(isFromQuery, resultIds) {
        router.push({
            name: 'ResultList',
            query: {
                isFromQuery,
                resultIds
            }
        })
    }
}

export { NavigationTool }
